
export const RightShipQiRouterConstants = {
    Home: 'home',
    Customers: 'customers',
    BusinessUnit: 'business-unit',
    Rules: 'rules',
    SurvivorshipRules: 'survivorship-rules',
    SurvivorshipRuleFailures: 'survivorship-rule-failures',
    SubtaskTypes: 'subtask-types',
    Lists: 'lists',
    ListItems: "ListItems",
    VesselComparison: "VesselComparison",
    CustomReports: 'custom-reports',
    CustomReport: 'custom-report',
    PowerBiReport: 'report',
    Customer: 'customer',
    CreateCustomer: 'create-customer',
    UpdateCustomer: 'update-customer',
    ApprovalPage: 'approval-page',
    MySubscription: 'my-subscription',
    Activities: 'activities',
    Inspectors: 'inspectors',
    Activity: 'activity',
    Companies: 'companies',
    RightshipInsights: 'rightship-insights',
    Company: 'company',
    Vet: 'vet',
    AutoScreening: 'auto-screening',
    VoyageDataSubmission: 'voyage-data-submission',
    EnvironmentalVerificationRequest: 'environmental-review-request',
    RequestAnEnvironmentalVerification: 'request-an-environmental-review',
    Vessels: "vessels",
    VesselOverview: "vessel-overview",
    VesselDetails: "vessel-details",
    ZeroHarmPartnerDetail: "zero-harm-partner-detail",
    VesselDetailsByImo: "vessel-details-by-imo",
    VesselDetailsByBKey: "vessel-details-by-bkey",
    AddPsc: "add-psc",
    AddIncident: "add-incident",
    NewFbr: "new-fbr",
    PTSubmitFbr: "submit-fbr",
    // removed as per PX-6404
    // MyFleetVessel: "myfleet-vessel-details",
    // MyFleet: 'my-fleet',
    Pipelines: 'pipelines',
    PipelineExecutions: 'pipeline-executions',
    PipelineExecution: 'pipeline-execution',
    VesselsSearch: "vessels-search",
    CompaniesSearch: 'companies-search',
    SearchHistory: "search-history",
    Feedback: "feedback",
    Settings: "settings",
    PSC: "psc",
    Incident: "incident",
    VetTaskOnboardingCustomContent: "vet-task-onboarding-custom-content",
    CrewWelfareOnboardingCustomContent: "crew-welfare-onboarding-custom-content",
    FbrOnboardingCustomContent: "fbr-onboarding-custom-content",
    TermsAndConditions: "terms-and-conditions",
    RightShipNotAuthorized: "rightship-not-authorized",
    MyAccount: "my-account",
    ListEmailHistory: "list-email-history",
    Fbr: "fbr",
    Cfr: "cfr",
    NewCfr: "new-cfr",
    SafetyScoreChange: "safety-score-change",
    VesselSafetyScoreChange: "vessel-safety-score-change",
    RightShipInspection: "rightship-inspection",
    AddRightShipInspection: "add-rightship-inspection",
    SafetyScoreReview: "safety-score-review",
    //For Client access
    RequestRightShipInspection: "request-rightship-inspection",
    EmailVerification: "email-verification",
    CarbonAccounting: "carbon-accounting",
    CarbonAccountingSummary: "carbon-accounting-summary",
    CarbonAccountingVoyageRecords: "carbon-accounting-voyage-records",
    CarbonAccountingEmissionsIntensity: "carbon-accounting-emissions-intensity",
    HowCarbonAccountingCanBeImproved: "how-carbon-accounting-can-be-improved",

    //MEP
    MEP: "mep",
    
    PdfDownloadLink: "pdf-download-link",

    //Ports and Terminals
    PortRiskProfile: "port-risk-profile",
    FeedbackReports: "feedback-reports",
    VesselPreArrival: "vessel-pre-arrival",
    Order: "order",
    RequestForQuote: "request-for-quote",
    Video: 'video',
    
    //Genesis?
    Dashboard: "dashboard",
    OnboardingPlugins: "onboarding-plugins-list",
    WorkflowConfiguration: "workflow-configuration",
    ManageEntities: "manage-entities",
    Onboardings: "onboardings-list",
    PersistOnboarding: "persist-onboarding",
    ManageLookups: "lookups",
    ManageScheduledMaintenances: "scheduled-maintenances",
} 